import NamedDto from 'modules/base/dto/NamedDto';

export class SensorValueEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {number} */
		this.externalId = null;
	}

	/**
	 * @typedef {Object} _SensorValueEditDtoProps
	 * @property {string} type
	 * @property {number} externalId;
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SensorValueEditDtoProps} SensorValueEditDtoProps
	 */
	/**
	 *
	 * @param {SensorValueEditDtoProps} props
	 * @returns {SensorValueEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.externalId = props.externalId;
		return this;
	}
}

export default SensorValueEditDto;
